module.exports = __webpack_public_path__ + "static/Biconomy-8b5289b46e0082bed0ac1c607e3fffbe.jpg";